import { render } from "./MeetAppLiveConsolidatedDetails.vue?vue&type=template&id=045a51e0&scoped=true&ts=true"
import script from "./MeetAppLiveConsolidatedDetails.vue?vue&type=script&lang=ts"
export * from "./MeetAppLiveConsolidatedDetails.vue?vue&type=script&lang=ts"

import "./MeetAppLiveConsolidatedDetails.vue?vue&type=style&index=0&id=045a51e0&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045a51e0"]])

export default __exports__